import { MediaQueries } from 'vue-media-queries';
import { respoBreakPointBands } from '../common';

export const mediaQueries = new MediaQueries({
	bands: respoBreakPointBands
});



// WEBPACK FOOTER //
// ../source/common/mediaQuery/mediaQuery.js